
import {computed, defineComponent, onMounted, PropType, reactive, ref} from 'vue'

export interface View {
  id: string
}

export default defineComponent({
  name: 'ControllableView',
  components: {},
  props: {
    modelValue: {
      type: String as PropType<View['id']>,
      // required: true
    },
    views: {
      type: Array as PropType<Array<View>>,
      required: true
    },
    defaultView: {
      type: String as PropType<View['id']>
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    function change (id: View['id']) {
      if (!props.views?.find(v => v.id === id)) return console.warn(`View.change: invalid view id ${id}`)
      emit('update:modelValue', id)
    }

    onMounted(() => {
      if (!props.modelValue && props.views?.length)
        emit('update:modelValue', props.defaultView || props.views[0].id)
    })

    return { change }
  }
})
